export default "__VITE_ASSET__qEgp2fQB__"